export default "__VITE_ASSET__Cgid22Dz__"